import {useAppSelector} from 'src/redux/storeHooks'
import {
  applyPlatformSettingShortcodes,
  PlatformSettingDisplayContext,
} from 'src/utils/platformSettingDisplayText'

export const usePlatformSettingDisplayContext = (
  sourceChannelName?: string | null
): PlatformSettingDisplayContext => {
  const {retrivedPlatformData} = useAppSelector((state) => state.retrivePlatformData)
  const {mainStoreData} = useAppSelector((state) => state.fetchConnectedPlatform)

  return {
    retrievedPlatform: retrivedPlatformData,
    mainStore: mainStoreData,
    sourceChannelName,
  }
}

export const useApplyPlatformSettingShortcodes = (sourceChannelName?: string | null) => {
  const context = usePlatformSettingDisplayContext(sourceChannelName)

  return (text: string | null | undefined) => applyPlatformSettingShortcodes(text, context)
}
